import {Button, Col, Form} from "react-bootstrap";

import emailjs from '@emailjs/browser'
import {useNavigate} from "react-router-dom";
import {useRef, useState} from "react";

const serviceID = 'service_m0ujnbn';
const templateID = 'template_r3rti6h';
const emailjsPublicKey = 'krdcx4yYv3T88TDy2';
const ContactForm = () => {
    const formRef = useRef();
    const navigate = useNavigate();
    const [contactMethod, setContactMethod] = useState('Cualquiera');
    const submitForm = async (e) => {
        if (!e) return;
        e.preventDefault()
        try {
            const response = await emailjs.sendForm(serviceID, templateID, formRef.current,
                {
                    publicKey: emailjsPublicKey,
                });
            if (response.status === 200) {
                navigate('/form-submitted');
            }
        } catch (e) {
            navigate('/error-page');
        }
    }
    return (
        <Col className={'border-1 border-black iframe-container'} md={4} sm={12}>
            <h2 className={'mb-1'}>Contactanos</h2>
            <span className={'mb-2 d-block'}>Si tenés dudas o algún inconveniente, no dudes en escribirnos.</span>
            <Form className={'mt-4 mt-lg-4'} ref={formRef} onSubmit={submitForm}>
                <Form.Label>Nombre</Form.Label>
                <Form.Control className={'mb-2'} name={'form_name'} type="input"
                              required={true}/>
                <Form.Label>Email</Form.Label>
                <Form.Group className="mb-3" controlId="form_email">
                    <Form.Control name={'form_email'} type="email"
                                  required={true}/>
                    <Form.Text className="text-muted">
                        No compartiremos tu email con nadie.
                    </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3" controlId="form_phone">
                    <Form.Label>Móvil</Form.Label>
                    <Form.Control name={'form_phone'} type="phone"
                                  required={true}/>
                    <Form.Text className="text-muted">
                        No compartiremos tu número con nadie.
                    </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3" controlId="form_message">
                    <Form.Label>Comentarios</Form.Label>
                    <Form.Control className={'mb-3'} name={'form_message'} type="input" as="textarea" required={true}/>
                </Form.Group>
                <input type="hidden" value={contactMethod} name={'form_contact_method'} id={'form_contact_method'}/>
                <Form.Group className="mb-3" controlId="form_contact_method_wrapper">
                    <Form.Label className={'w-100'}>Prefiero que me contacten por:</Form.Label>
                    <Form.Check
                        inline
                        onChange={() => setContactMethod('Whatsapp')}
                        name={'form_contact_method_w'}
                        label="Whatsapp"
                        type={'radio'}
                    />
                    <Form.Check
                        inline
                        onChange={() => setContactMethod('Email')}
                        name={'form_contact_method_e'}
                        label="Email"
                        type={'radio'}
                    />
                    <Form.Check
                        inline
                        onChange={() => setContactMethod('Llamado')}
                        name={'form_contact_method_l'}
                        label="Llamado"
                        type={'radio'}
                    />
                    <Form.Check
                        inline
                        onChange={() => setContactMethod('Cualquiera')}
                        name={'form_contact_method_c'}
                        label="Cualquiera"
                        defaultValue={'checked'}
                        type={'radio'}
                    />
                </Form.Group>
                <Button onClick={() => submitForm()} variant="primary" type="submit"
                        className={'w-100 contact-form-button'}>
                    Enviar
                </Button>
            </Form>
        </Col>
    );
}
export default ContactForm;